import React, { Component } from 'react'
import Button from '../components/Button'
import FormGroup from '../components/FormGroup'
import server from '../server'

class InfobaseItem extends Component {
  render() {
    const info = this.props.info;
    
    return (
      <li key={ this.props.key }>
        <button className="table__title" onClick={ () => this.props.handleGetModalInfo(info.uri) }>
          <span>{info.pagetitle}</span>
        </button>
        <p className="table__longtitle">{info.longtitle}</p>
        <p className="table__description">{info.introtext}</p>
        <p className="table__link">
          <a className={info.document? '' : 'hide'} href={'/'+info.document} target={info.document !== 'login' && '_blank'}>
            <i className="ico_arrow ico_arrow_success ico_arrow_small ico_arrow_middle"></i>
            <span>сказать</span>
          </a>
        </p>
      </li>
    );
  }
}

class Infobase extends Component {

  state = {
    
    filters: {
      product: 0,
      version: 0,
    },

    productNames: [],
    versions: [],

    loading: true,
    page: false,
  }

  componentDidMount() {
    if( this.state.page ) return 0;

    const token = this.props.user ? '?token='+this.props.user.token : '';

    fetch(server.uri+'page/infobase'+token, server.params)
      .then( response => response.json() )
      .then( data => {

        const items = data.items,
          productNames = [],
          versions = [];

        items.forEach(v => {
          const vn = v.pagetitle;
          if( productNames.indexOf(vn) === -1 )
            productNames.push(vn);
        });

        items.forEach(v => {
          const vn = v.longtitle;

          if( versions.indexOf(vn) === -1 )
            versions.push( vn );
        });
        
        this.setState({
          loading: false,

          versions: versions,
          productNames: productNames,
          page: data,
        })
      })
  }

  handleChange = v => {
    this.setState({
      filters: Object.assign( this.state.filters, { [v.name]: v.value })
    });

    console.log(this.state.filters)
  }

  handleSubmit(e) {
    e.preventDefault();
    console.log(this.state)
  }
  
  render() {

    if( this.state.loading )
      return <div className="loading"></div>;

    const page = this.state.page,
      filters = this.state.filters,
      formSettings = {
        type: 'select',
        handleChange: e => this.handleChange(e),
      };

    return (
      <div className="page-infobase">
        <header className="main__header">
        
          <h1 className="main__title">{page.pagetitle}</h1>
          
          <form className="filters" onSubmit={ e => this.handleSubmit(e) }>
            <FormGroup placeholder="выберите продукт" name="product" value={filters.product} values={this.state.productNames} {...formSettings}/>
            <FormGroup placeholder="выберите вашу версию" name="version" value={filters.version} values={this.state.versions} {...formSettings}/>

            <Button class="hide"/>
          </form>
        </header>

        <section className="table__container">
          <div className="table">
            <header>
              <ul>
                <li className="table__title">Продукт</li>
                <li className="table__longtitle">Версия</li>
                <li className="table__description">Краткое описание</li>
              </ul>
            </header>
            
            <ul>
              { page && page.items.map( (v,i) => {

                if(
                  ( filters.product && filters.product !== v.pagetitle )
                  || ( filters.version && filters.version !== v.longtitle )
                  )
                  return '';
                
                return <InfobaseItem key={i} info={v}/>
              })}
            </ul>
          </div>
        </section>
      </div>
    );
  }
}
export default Infobase;
